import { saveResource, fetchResources, fetchResourceById } from '@/connectors/ras';
import { mapAsync } from '@/utils/array';

const initialState = () => ({
  resources: [],
  filters: { limit: 48, offset: 0 },
});

const getters = {
  currentMaterial: (state) => state.material,
  materials: (state) => state.resources,
  materialFilters: (state) => state.filters,
};

const mutations = {
  setMaterials(state, material) {
    Object.assign(state, { resources: material });
  },
  setMaterialFilters(state, filters) {
    Object.assign(state, { filters: { ...state.filters, ...filters } });
  },
  setCurrentMaterial(state, data) {
    Object.assign(state, { material: data });
  },
};

const actions = {
  async createMaterial({ rootState }, materialData) {
    const newMaterialData = materialData;
    newMaterialData.data.textures = await mapAsync(materialData.data.textures, async (texture) => {
      const newTexture = await saveResource(
        { name: texture.name, data: texture.data },
        { request: rootState.users.user.session.request, resourceType: 'texture' },
      );
      return { channel: texture.channel, id: newTexture.shortId, name: texture.name };
    });
    return saveResource(newMaterialData, { request: rootState.users.user.session.request, resourceType: 'material' });
  },
  async fetchMaterialById({ rootState, commit }, id) {
    const response = await fetchResourceById(
      { id },
      { request: rootState.users.user.session.request, resourceType: 'material' },
    );
    commit('setCurrentMaterial', response.data);
  },
  async fetchMaterials({ state, rootState, commit }) {
    const response = await fetchResources(state.filters, {
      request: rootState.users.user.session.request,
      resourceType: 'material',
    });
    commit('setMaterials', response.data.objects);
    commit('setMaterialFilters', response.data.meta);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
